import * as THREE from "three";
import SolidGeometry from "./solid-geometry";

// Base retangular (largura x profundidade) embaixo e ápice no topo
export default class PyramidGeometry extends SolidGeometry {
  constructor(color, { width, height, depth }, positions) {
    // Cone de 4 lados girado 45° vira uma base quadrada alinhada aos eixos, de lado 1
    const geometry = new THREE.ConeGeometry(Math.SQRT1_2, 1, 4);
    geometry.rotateY(Math.PI / 4);
    geometry.scale(width, height, depth);
    super("pyramid", color, geometry, positions);
  }
}
